import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound = () => (
  <div className="flex flex-col items-center gap-4 px-6 py-32 text-center" data-testid="not-found">
    <p className="font-serif text-7xl text-burgundy">404</p>
    <h1 className="font-serif text-3xl text-charcoal">Page Not Found</h1>
    <p className="text-muted-text">The page you're looking for doesn't exist or has moved.</p>
    <Button asChild className="rounded-none bg-burgundy"><Link to="/">Back to Home</Link></Button>
  </div>
);

export default NotFound;
